<div class="cash-dialog">
  <div class="dialog-header">
    <div class="header-title">
      <mat-icon class="header-icon">receipt_long</mat-icon>
      <div>
        <h2 mat-dialog-title class="title-text">Remise de chèques</h2>
        <span class="subtitle-text">{{ scopeLabel }}</span>
      </div>
    </div>
    <button mat-icon-button type="button" (click)="close()" [disabled]="sending" aria-label="Fermer" class="btn-close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    @if (done) {
      <div class="msg msg-ok done-msg">
        <mat-icon>check_circle</mat-icon>
        <span>{{ done.msg }}</span>
      </div>
      @if (printError) {
        <div class="msg msg-error">
          <mat-icon>error_outline</mat-icon>
          <span>Bordereau non imprimé : {{ printError }}</span>
        </div>
      }
    } @else {
      @if (loadError) {
        <div class="msg msg-error">
          <mat-icon>error_outline</mat-icon>
          <span>Lecture des chèques impossible : {{ loadError }}</span>
        </div>
        <button mat-stroked-button type="button" class="btn-retry" (click)="loadPortfolio()">Réessayer</button>
      }

      @if (portfolio) {
        <div class="cheques-scroll">
          <table class="grid cheques">
            <thead>
              <tr>
                <th class="c-check">
                  <mat-checkbox id="crm-all" [checked]="allChecked" [indeterminate]="someChecked" [disabled]="!cheques.length"
                    (change)="toggleAll($event.checked)" aria-label="Tout cocher"></mat-checkbox>
                </th>
                <th class="c-day">Date</th>
                <th>Poste</th>
                <th>Tireur</th>
                <th>Commentaire</th>
                <th class="num">Montant</th>
              </tr>
            </thead>
            <tbody>
              @for (c of cheques; track c.id) {
                <tr [class.off]="!isChecked(c.id)">
                  <td class="c-check">
                    <mat-checkbox [checked]="isChecked(c.id)" (change)="toggle(c.id, $event.checked)" [aria-label]="'Chèque ' + c.id"></mat-checkbox>
                  </td>
                  <td class="c-day">{{ day(c.dat) }}</td>
                  <td class="c-station">
                    {{ stationName(c) }}
                    @if (data.store === null) { <span class="sub">{{ c.store_name ?? ('Magasin ' + c.store) }}</span> }
                  </td>
                  <td class="c-customer">
                    {{ c.customer_name }}
                    @if (c.legacy) { <span class="legacy" matTooltip="Chèque repris de l'ancien logiciel">Reprise</span> }
                  </td>
                  <td class="c-comment">{{ c.comment }}</td>
                  <td class="num">{{ c.amount | fc }} €</td>
                </tr>
              } @empty {
                <tr><td colspan="6" class="empty">Aucun chèque à remettre {{ windowLabel }}</td></tr>
              }
            </tbody>
          </table>
        </div>

        <div class="selection">
          <span id="crm-count">{{ checkedIds.length }} chèque{{ checkedIds.length > 1 ? 's' : '' }} coché{{ checkedIds.length > 1 ? 's' : '' }} sur {{ cheques.length }}</span>
          <span class="sel-total">Total <b id="crm-total" class="num">{{ checkedTotal | fc }} €</b></span>
        </div>

        <div class="field">
          <label class="field-label" for="crm-bank">Banque qui reçoit</label>
          @if (banks?.length) {
            <select id="crm-bank" class="custom-select" [(ngModel)]="bank">
              <option [ngValue]="null" disabled>Choisir la banque…</option>
              @for (b of banks; track b.id) {
                <option [ngValue]="b.id">{{ bankLabel(b) }}</option>
              }
            </select>
          } @else if (banks) {
            <div class="msg msg-warn no-bank">
              <mat-icon>info_outline</mat-icon>
              <span>{{ noBankMsg }}</span>
            </div>
          }
          @if (banksError) {
            <div class="msg msg-error">
              <mat-icon>error_outline</mat-icon>
              <span>Lecture des banques impossible : {{ banksError }}</span>
            </div>
          }
        </div>

        @if (!data.canRemit) {
          <div class="note reserved-note">{{ reservedMsg }}</div>
        }
      }

      @if (sendError) {
        <div class="msg msg-error">
          <mat-icon>error_outline</mat-icon>
          <span>{{ lost ? '' : 'Remise refusée : ' }}{{ sendError }}</span>
        </div>
      }
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dialog-actions">
    @if (done) {
      <button mat-stroked-button type="button" id="crm-print" class="btn-submit" (click)="print()">
        <mat-icon>print</mat-icon>
        <span>Imprimer le bordereau</span>
      </button>
      <button mat-flat-button color="primary" type="button" id="crm-close" (click)="close()">Fermer</button>
    } @else {
      <button mat-button type="button" (click)="close()" [disabled]="sending">Fermer</button>
      <button mat-stroked-button type="button" id="crm-reload" class="btn-submit" [disabled]="sending" (click)="loadPortfolio()"
        matTooltip="Relire les chèques à remettre">
        <mat-icon>refresh</mat-icon>
        <span>Recharger</span>
      </button>
      @if (data.canRemit) {
        <button mat-flat-button color="primary" type="button" id="crm-validate" class="btn-submit" [disabled]="!canValidate" (click)="validate()">
          <mat-icon>print</mat-icon>
          <span>Valider la remise et imprimer</span>
        </button>
      }
    }
  </mat-dialog-actions>
</div>
